import { render, staticRenderFns } from "./FAQWeb.vue?vue&type=template&id=16b65e86"
import script from "./FAQWeb.vue?vue&type=script&lang=js"
export * from "./FAQWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports